import './frontend.scss';

const Expandable = require( './components/expandable' ).default;

// Get all the different expandable elements.
const accordions = document.querySelectorAll( '.wp-block-rte-accordion-item' );

// If there are accordions load the class and use it.
if ( accordions.length !== 0 ) {
	accordions.forEach( ( accordion ) => {
		accordion.classList.add( 'expandable' );
	} );

	// Set up the expandable functionality.
	accordions.forEach( ( accordion ) => {
		new Expandable( accordion );
	} );
}
